module.exports = __webpack_public_path__ + "img/V28.d78095cf.png";